<template>
	<div class="page-wrapper">
		<router-view/>
		<message-widget></message-widget>
		<cookie-widget></cookie-widget>
	</div>
</template>

<script>
import MessageWidget from '@/components/widgets/MessageWidget'
import CookieWidget from '@/components/widgets/CookieWidget'

export default {
  name: 'app',
  components: {MessageWidget, CookieWidget}
}
</script>



// WEBPACK FOOTER //
// src/App.vue